import { ButtonGroup } from "@vds/buttons";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { createRuleEndPoint, editRuleEndPoint } from "../../../configuration";
import { getRandomUUID } from "../../../Token";
import { BreadcrumbItem, Breadcrumbs } from "@vds/breadcrumbs";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import axiosInstance from "../../../global/axiosInterceptor";

function getConditionSymbol(ruleCondition) {
  const availableCondition = {
    "Greater Than": ">",
    "Less Than": "<",
    "Greater Than OR Equal To": ">=",
    "Less Than OR Equal To": "<=",
    "Equal To": "=",
    "NOT Equal To": "!=",
  };
  return availableCondition[ruleCondition] || "";
}

const CreateRuleSummary = () => {
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  let navigate = useNavigate();
  const { state } = useLocation();
  let ruleInfo = state;
  console.log(ruleInfo);
  const onEdit = async () => {
    const response = await axiosInstance.put(editRuleEndPoint(), {
      accountname: ruleInfo.deviceDetails.billingaccountid,
      ruleid: ruleInfo.ruleId,
      name: ruleInfo.ruleName,
      deviceid: ruleInfo.deviceDetails.uid,
      condition:
        "$[?(@.eventMsg.fields." +
        ruleInfo.selectedField +
        " " +
        getConditionSymbol(ruleInfo.selectedCondition) +
        " " +
        ruleInfo.thresholdValue +
        ")]",
      severity: ruleInfo.selectedSeverity,
      contactGroup: ruleInfo.selectedGroup.name,
      alertMessage: ruleInfo.alertMessage,
      "email-to": ruleInfo.sendEmail ? ruleInfo.selectedGroup.email : "",
      "email-subject": ruleInfo.sendEmail
        ? ruleInfo.selectedSeverity + " alert for " + ruleInfo.selectedField
        : "",
      "email-body": ruleInfo.sendEmail
        ? ruleInfo.selectedField +
          " is " +
          ruleInfo.selectedCondition +
          " " +
          ruleInfo.thresholdValue
        : "",
      "sms-to": ruleInfo.sendSMS ? ruleInfo.selectedGroup.phoneNumber : "",
      "sms-subject": ruleInfo.sendSMS
        ? ruleInfo.selectedSeverity + " alert for " + ruleInfo.selectedField
        : "",
      "sms-body": ruleInfo.sendSMS
        ? ruleInfo.selectedField +
          " is " +
          ruleInfo.selectedCondition +
          " " +
          ruleInfo.thresholdValue
        : "",
      alertType: ruleInfo.alertType,
      location: ruleInfo.location,
      notification:
        ruleInfo.sendEmail && ruleInfo.sendSMS
          ? "sms-email"
          : ruleInfo.sendSMS && !ruleInfo.sendEmail
          ? "sms"
          : ruleInfo.sendEmail && !ruleInfo.sendSMS
          ? "email"
          : "",
    });
    const editRuleRsp = response.data;
    console.log(editRuleRsp);

    console.log(ruleInfo);
    navigate("/rules");
  };

  const onNext = async () => {
    const response = await axiosInstance.post(createRuleEndPoint(), {
      accountname: ruleInfo.deviceDetails.billingaccountid,
      name: ruleInfo.ruleName,
      deviceid: ruleInfo.deviceDetails.uid,
      condition:
        "$[?(@.eventMsg.fields." +
        ruleInfo.selectedField +
        " " +
        getConditionSymbol(ruleInfo.selectedCondition) +
        " " +
        ruleInfo.thresholdValue +
        ")]",
      severity: ruleInfo.selectedSeverity,
      contactGroup: ruleInfo.selectedGroup.name,
      alertMessage: ruleInfo.alertMessage,
      "email-to": ruleInfo.sendEmail ? ruleInfo.selectedGroup.email : "",
      "email-subject": ruleInfo.sendEmail
        ? ruleInfo.selectedSeverity + " alert for " + ruleInfo.selectedField
        : "",
      "email-body": ruleInfo.sendEmail
        ? ruleInfo.selectedField +
          " is " +
          ruleInfo.selectedCondition +
          " " +
          ruleInfo.thresholdValue
        : "",
      "sms-to": ruleInfo.sendSMS ? ruleInfo.selectedGroup.phoneNumber : "",
      "sms-subject": ruleInfo.sendSMS
        ? ruleInfo.selectedSeverity + " alert for " + ruleInfo.selectedField
        : "",
      "sms-body": ruleInfo.sendSMS
        ? ruleInfo.selectedField +
          " is " +
          ruleInfo.selectedCondition +
          " " +
          ruleInfo.thresholdValue
        : "",
      alertType: ruleInfo.alertType,
      location: ruleInfo.location,
      notification:
        ruleInfo.sendEmail && ruleInfo.sendSMS
          ? "sms-email"
          : ruleInfo.sendSMS && !ruleInfo.sendEmail
          ? "sms"
          : ruleInfo.sendEmail && !ruleInfo.sendSMS
          ? "email"
          : "",
    });
    const createRuleRsp = response.data;
    console.log(createRuleRsp);

    console.log(ruleInfo);
    navigate("/rules");
  };

  const onExit = () => {
    navigate(-1);
  };

  const onCancelEdit = () => {
    let ruleList = JSON.parse(sessionStorage.getItem("ruleList"));
    let ruleDetails = ruleList.filter((rule) => rule.id === ruleInfo.ruleId);
    console.log(ruleDetails);
    navigate("/createRule", { state: ruleDetails[0] });
  };

  if (!ruleInfo) return navigate("/rules");

  return (
    <>
      <h1 className={"font-face-vzb"}>
        {ruleInfo?.editRule ? "Update" : "Create"} rule
      </h1>
      {/*<p className={"font-face-vzb"}> Dashboard / Rules / Rules configurator</p>*/}
      <div style={{ marginLeft: ".5%" }}>
        <Breadcrumbs surface="light">
          <BreadcrumbItem>
            <Link
              data-testid="createRuleSummary_dashboardLink"
              to="/dashboard"
              className="breadcrums-item_link"
            >
              Dashboard
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link
              data-testid="createRuleSummary_rulesLink"
              to="/rules"
              className="breadcrums-item_link"
            >
              Rules
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>Rules configurator</BreadcrumbItem>
        </Breadcrumbs>
      </div>

      <div style={{ margin: 40 }}>
        <h5 className={"font-face-vz"}>Rule Summary</h5>
        <br />
        <br />
        <br />
        <h5 className={"font-face-vzb"}>
          {ruleInfo.selectedField}&nbsp;{ruleInfo.selectedCondition}&nbsp;
          {ruleInfo.thresholdValue}
        </h5>
        <br />
        <br />
        <br />
        <h5 className={"font-face-vz"}>
          All {ruleInfo.selectedGroup.name} and users with access to ThingSense
        </h5>
        <h5 className={"font-face-vz"}>
          will be notified when the rule is triggered
        </h5>
        <br />
        <br />
        <br />
        {ruleInfo.editRule ? (
          <ButtonGroup
            childWidth={"100%"}
            viewport={"desktop"}
            rowQuantity={{ desktop: 2 }}
            data={[
              {
                children: "Exit",
                size: "large",
                use: "secondary",
                width: "100px",
                "data-testid": "createRuleSummary_cancelButtonGroup",
                onClick: onCancelEdit,
              },
              {
                children: "Update and view",
                size: "large",
                use: "primary",
                width: "200px",
                "data-testid": "createRuleSummary_updateAndViewButtonGroup",
                onClick: onEdit,
              },
            ]}
            alignment={"left"}
          />
        ) : (
          <ButtonGroup
            childWidth={"100%"}
            viewport={"desktop"}
            rowQuantity={{ desktop: 2 }}
            data={[
              {
                children: "Exit",
                size: "large",
                use: "secondary",
                width: "100px",
                "data-testid": "createRuleSummary_exitButtonGroup",
                onClick: onExit,
              },
              {
                children: "Add and view",
                size: "large",
                use: "primary",
                width: "175px",
                "data-testid": "createRuleSummary_addAndViewButtonGroup",
                onClick: onNext,
              },
            ]}
            alignment={"left"}
          />
        )}
      </div>
    </>
  );
};

export default CreateRuleSummary;
